import { Avatar, Box, Button, ButtonGroup, Center, Grid, GridItem, Text, useDisclosure } from "@chakra-ui/react";
import { Container, Dev, Heading, Icon, IconButton, Pressable, Scope, Searchable } from "components";
import { useProducts } from "hooks";
import { useState } from "react";
import { useNavigate } from "react-router";
import Create from "./create";

export default function Products(){

    const create = useDisclosure()
    const [ term, setTerm ] = useState('')
    const products = useProducts(term)

    return(
    <>
    <Container>
        
        <Heading title="Produtos">
            <ButtonGroup size="xs" isDisabled={products.isFetching}>
                <Scope role="manage_products">
                    <Button children="Registrar produto" leftIcon={<Icon name="add" />} colorScheme="teal" onClick={create.onOpen} />
                </Scope>
                <IconButton label="Atualizar" icon="refresh" isLoading={products.isFetching} onClick={products.refetch} />
                <Dev data={products.data} />
            </ButtonGroup>
        </Heading>

        <Searchable placeholder="Procurar pelo nome do produto..." value={term} setValue={setTerm} />

        <Grid templateColumns="23% 23% 23% 23%" gap={6} mt={10}>
            { products.data?.map(item => <GridItem key={item.id}><Product data={item} /></GridItem>) }
        </Grid>
    </Container>

    <Create {...create} />
    </>
    )
}

const Product = ({ data }) => {

    const navigate = useNavigate()

    return(
    <Pressable onClick={() => navigate(`/products/${data.id}`)}>
        <Box w="100%" p={4} backgroundColor="rgba(0,0,0,0.01)" borderRadius={4}>
            {/* <Center><Avatar name={data.name} src={data.image_url} size="lg" /></Center> */}
            <Box w="100%" h="200px" backgroundSize="cover" backgroundPosition="center" backgroundImage={data.image_url} />
            <Box textAlign="center">
                <Text color="GrayText" fontSize="xs" children={`${data?.category?.name} | ${data?.supplier?.name}`} />
                <Text fontSize="xs" fontWeight="bold" textTransform="uppercase" children={data.name} />
            </Box>
        </Box>
    </Pressable>
    )
}